import React from "react";
import Footer from "../../components/Footer";
import StaffForm from "../../components/forms/Communicate/Staff"
import NavBar from "../../components/navbar-components/NavBar";

const Staff = () => {
    return (
        <>
        <NavBar/>
        <div className="bg-gray-200 py-5">
            <StaffForm/>
        </div>
        <Footer/>
        </>
    )
}

export default Staff